import { nsPlan } from '@/app/i18n/namespaces';
import Info from '@/common-utils/components/renders/info/Info';
import ICONS from '@/common-utils/enums/icons';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    SHOULD_AUTO_ACTIVATE_SUBSCRIPTIONS: {
        key: 'shouldAutoActivateSubscriptions',
        type: FIELD_TYPES.BOOLEAN,
        entity: 'keys.auto_activate_short',
        namespace: nsPlan,
        enableSorting: true,
        extraInfo: ({ show }) => (show && <Info entity='keys.auto_activate_alert' namespace={nsPlan} icon={ICONS.DEFAULT_PLAN} variant='success' />)
    },
    LABEL: {
        key: 'label',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.label',
        namespace: nsPlan,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.label'
    },
    PRODUCT_CODE: {
        key: 'productCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.product_code',
        namespace: nsPlan,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT,
        placeholder: 'filter.placeholder.product_code'
    },
    PARENT_SUBSCRIPTION_PLAN: {
        key: 'parentSubscriptionPlan',
        LABEL: {
            parentKeys: ['parentSubscriptionPlan'],
            key: 'label',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.parent_subscription_label',
            namespace: nsPlan,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.parent_subscription_label',
            isNested: true
        },
        UUID: {
            parentKeys: ['parentSubscriptionPlan'],
            key: 'uuid'
        }
    },
    OWNER_ORGANIZATION: {
        key: 'ownerOrganization'
    },
    ALLOWED_CLIENTS: {
        key: 'allowedClients',
        entity: 'plan_allowed_clients',
        type: FIELD_TYPES.ARRAY,
        UUID: {
            parentKeys: ['allowedClients'],
            key: 'uuid'
        },
        LEGAL_NAME: {
            parentKeys: ['allowedClients'],
            key: 'legalName'
        }
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.created_at',
        namespace: nsPlan,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.updated_at',
        namespace: nsPlan,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    SHOULD_BLOCK_NEW_POS: {
        key: 'shouldBlockNewPOS',
        type: FIELD_TYPES.TEXT,
        entity: 'organization_should_block_new_pos_title',
        namespace: nsPlan
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    }
};